import { render, staticRenderFns } from "./QuestionnaireInvestigation.vue?vue&type=template&id=76852fa2&scoped=true"
import script from "./QuestionnaireInvestigation.vue?vue&type=script&lang=js"
export * from "./QuestionnaireInvestigation.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireInvestigation.vue?vue&type=style&index=0&id=76852fa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76852fa2",
  null
  
)

export default component.exports